<template>
    <div class="w-header">
        <div class="w-header__inner">
            <div class="w-header__logo">
                <a href="https://www.ludovico.at/"><span>Ludovico</span></a>
            </div>
            <h1 class="w-header__title">Spielesuche</h1>
            <ListFilter class="w-header__list-filter" />
            <ListExtendedFilter class="w-header__list-extended-filter" />
            <a class="w-header__info" target="_blank" href="https://www.ludovico.at/ludothek/"
                ><span>Infos</span
                ><icon width="32" height="32" data="@icons/info.svg"
            /></a>
        </div>
    </div>
</template>

<script>
import ListFilter from './ListFilter.vue';
import ListExtendedFilter from './ListExtendedFilter.vue';

export default {
    name: 'Header',
    components: {
        ListFilter,
        ListExtendedFilter,
    },
};
</script>

<style lang="scss">
@import "@/styles/_base.scss";
@import "@/styles/objects/_format.scss";

.w-header {
    border-bottom: 1px solid w-get-color("bordergray");
    background-color: w-get-color("white");
}
.w-header__inner {
    position: relative;
    padding-top: $w-gutter;
}
.w-header__logo {
    text-align: center;

    a {
        display: inline-block;
        width: 12em;
        height: 6em;
        background-image: url("~@/assets/images/logo.svg");
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
    }
    span {
        @include w-u-hide;
    }
}
.w-header__title {
    @include w-o-format("h2");

    text-align: center;
    color: w-get-color("yellow");
}
.w-header__list-filter {
    margin-top: $w-gutter*1;
}
.w-header__list-extended-filter {
    margin-top: $w-gutter*0.5;
}
.w-header__info {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.5em;

    color: w-get-color("darkgray");

    span {
        opacity: 0;
        visibility: hidden;
        display: inline-block;
        padding: 0.5em;
        @include w-o-format("small");
    }
    &:focus,
    &:hover {
        color: w-get-color("red");
        span {
            opacity: 1;
            visibility: visible;
            color: w-get-color("darkgray");
        }
    }
}
</style>
